// A caching and otherwise updated version of:
// https://kentcdodds.com/blog/replace-axios-with-a-simple-custom-fetch-wrapper

import qs from 'qs';


import { POST, GET } from '.';


const CACHED = {};

async function cachedClient(data, _resource) {
	let resource = _resource(data);
	let method = resource.method;
	let url = resource.url;
	let body = resource.body;	
	let cacheOptions = resource.cache;	

	let cacheKey = getCacheKey(url, method, data);

	if(cacheKeyValid(cacheKey)) {
		console.log("%o is cached...", cacheKey);
		return getCacheItem(cacheKey);
	}
	else {
//		console.log("doing http request: %s", url);
		let response = await client(url, method, body, resource.config);
//		console.log("response: %o", response);
		addToCache(cacheKey, response, resource.config);

		return response;
	}
}


function getCacheKey(url, method, data) {
	if(method === POST)
		return null;
	
	return [url, method, qs.stringify(data)].join('x');
}

function addToCache(cacheKey, data, config={ cache: {} }) {
	
	let now = new Date().getTime();
	let minutes = (config.cache.minutes ? config.cache.minutes : 1);
//	console.log("Adding to cache for %d minutes", minutes);
	const expires = new Date(now + (minutes * 60000));
	
	CACHED[cacheKey] = {
		data: data,
		expires: expires
	};
}

function getCacheItem(cacheKey) {
	const item = cacheKey ? CACHED[cacheKey] : undefined;
	return (item !== undefined)  ? item.data : undefined;
}

function cacheItemValid(item) {
	if(item !== undefined) {
		if(item.expires.getTime() > new Date().getTime()) {
			return true;
		}
	}
	return false;
}

function cacheKeyValid(cacheKey) {
	if(!cacheKey) return false;
	return cacheItemValid(CACHED[cacheKey]);
}




async function client(endpoint, method, body={}, customConfig={}) {
	
	const headers = { 'Content-Type': 'application/json' };
	const config = {
		method: method,
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	};

	if (method === POST) {
		if(window.pageVariables.morty_token)
			body = {'morty_token': window.pageVariables.morty_token, ...body};
		config.body = qs.stringify(body);
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	}
	else if(window.pageVariables.morty_token) {
		endpoint += (endpoint.indexOf('?') === -1 ? '?' : '&');
		endpoint += "morty_token=" + encodeURI(window.pageVariables.morty_token);
	}

	
	let data;
	try {
		const response = await window.fetch(endpoint, config);
		
		data = await response.json();
		if (response.ok) {
			return data;
		}
		throw new Error(response.statusText);
	} catch (err) {
		console.error("Error: %o", err);
		return Promise.reject(err.message ? err.message : data);
	}
}

client.get = function (endpoint, customConfig = {}) {
	return client(endpoint, GET, null, { ...customConfig });
};

client.post = function (endpoint, body, customConfig = {}) {
	return client(endpoint, POST, body, { ...customConfig });
};

export { cachedClient, client };
